<script lang="ts" setup>
defineProps({
  hasBorders: {
    default: true,
    type: Boolean,
  },
  limit: {
    default: 0,
    type: Number,
  },
})

const { t } = useI18n()
const teamsStore = useTeamsStore()

await callOnce('webhooks', async () => {
  if (!teamsStore.webhooks.length) {
    await teamsStore.fetchTeamWebhooks()
  }
})
</script>

<template>
  <div
    class="flex flex-col gap-4 text-left"
    :class="{ 'gradient-texture-reverse rounded-xl bg-gray-100 p-4 shadow ring-1 ring-gray-200 md:p-6 dark:bg-gray-900 dark:ring-gray-800': hasBorders }"
  >
    <ul
      v-if="teamsStore.webhooks.length"
      class="divide-y divide-gray-200 dark:divide-gray-800"
      role="list"
    >
      <ApiWebhooksBoxItem
        v-for="webhook in teamsStore.webhooks.slice(0, limit || teamsStore.webhooks.length)"
        :key="webhook.id"
        :webhook="webhook"
      />
    </ul>

    <BaseMessage
      v-else
      :description="t('empty.description')"
      power-size="xs"
      :title="t('empty.title')"
    />
  </div>
</template>

<i18n lang="json">
{
  "en": {
    "empty": {
      "description": "Create a webhook to receive a notification for important events.",
      "title": "No webhook found"
    }
  },
  "es": {
    "empty": {
      "description": "Crea un webhook para recibir una notificación para eventos importantes.",
      "title": "No se encontró ningún webhook"
    }
  },
  "fr": {
    "empty": {
      "description": "Créez un webhook pour recevoir une notification pour les événements importants.",
      "title": "Aucun webhook trouvé"
    }
  }
}
</i18n>
